// News overlay — GDELT DOC news/media coverage ('NEW') as neutral (oval)
// frames with a flat category tint (blue), matching the other category
// layers (sanctions=red, conflicts=amber, …). News is stamped LOW severity
// at ingest (gdelt_news.py DEFAULT_SEVERITY) so it reads as background to the
// conflict/sanction/seismic markers wherever severity drives ordering/size.

import type { intel as i } from '@eidollon/contracts';
import { buildIconLayer } from './_icon-builder.js';
import { withGeom } from './_shared.js';
import type { LayerSpec } from './registry.js';

const TYPES: readonly i.SignalType[] = ['NEW'];
const TYPE_SET = new Set<i.SignalType>(TYPES);

export const newsLayer: LayerSpec = {
  id: 'news',
  label: 'NEW · news',
  kind: 'icon',
  signalTypes: TYPES,
  color: 'var(--blue)',
  colorAxis: 'category',
  description: 'GDELT global news / media coverage',
  classification: 'OPEN',
  legend: {
    swatch: 'var(--blue)',
    label: 'NEW',
    hint: 'GDELT worldwide news articles',
  },
  select: (rows) => withGeom(rows).filter((r) => TYPE_SET.has(r.signal_type)),
  // Always visible — the feed is capped at ~200 rows so there is no clutter,
  // and a single-type filter must show that type at ANY zoom (otherwise the
  // map goes empty below the old threshold). See route bug: "toggle on -> disappear".
  visibleAtZoom: () => true,
  deckLayer: ({ rows, viewport, onPick }) => {
    const data = withGeom(rows).filter((r) => TYPE_SET.has(r.signal_type));
    return buildIconLayer({
      id: 'intel-news',
      rows: data,
      zoom: viewport.zoom,
      sizeMin: 10,
      sizeMax: 24,
      onPick,
    });
  },
};
